import { useEffect, useMemo, useState } from 'react';
import { FiFileText, FiInbox } from 'react-icons/fi';
import DashboardLayout from '../../components/layout/DashboardLayout';
import SectionCard from '../../components/ui/SectionCard';
import ListItem from '../../components/ui/ListItem';
import EmptyState from '../../components/ui/EmptyState';
import StatusBadge from '../../components/ui/StatusBadge';
import { useAuth } from '../../context/AuthContext';
import { getSubmissionsByUser } from '../../services/submissionService';
import { formatDateTime } from '../../utils/format';

const FILTERS = [
  { value: 'all', label: 'Todos' },
  { value: 'pending', label: 'Pendientes' },
  { value: 'approved', label: 'Aprobados' },
  { value: 'rejected', label: 'Rechazados' },
];

export default function MyRecordsView() {
  const { user } = useAuth();
  const [submissions, setSubmissions] = useState(null);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    let active = true;
    getSubmissionsByUser(user.id).then((data) => {
      if (active) setSubmissions(data);
    });
    return () => {
      active = false;
    };
  }, [user.id]);

  const filtered = useMemo(() => {
    if (!submissions) return [];
    if (filter === 'all') return submissions;
    return submissions.filter((s) => s.status === filter);
  }, [submissions, filter]);

  return (
    <DashboardLayout title="Mis registros" subtitle={`${submissions?.length ?? 0} en total`}>
      <div className="chip-row">
        {FILTERS.map((f) => (
          <button
            key={f.value}
            type="button"
            className={`chip${filter === f.value ? ' is-active' : ''}`}
            onClick={() => setFilter(f.value)}
          >
            {f.label}
          </button>
        ))}
      </div>

      <SectionCard title="Historial">
        {submissions === null && <EmptyState icon={<FiFileText />} title="Cargando registros…" />}
        {submissions !== null && filtered.length === 0 && (
          <EmptyState
            icon={<FiInbox />}
            title="No hay registros"
            description="No encontramos registros con este filtro."
          />
        )}
        {filtered.map((item) => (
          <ListItem
            key={item.id}
            icon={<FiFileText />}
            title={item.formTitle}
            meta={`${formatDateTime(item.submittedAt)} · ${item.location}`}
            right={<StatusBadge status={item.status} />}
          />
        ))}
      </SectionCard>
    </DashboardLayout>
  );
}
